module.exports = __webpack_public_path__ + "static/media/support.843683d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/support.svg
// module id = 600
// module chunks = 0